// @ts-nocheck
import { Divider } from "antd";
import { Fragment } from "preact";
import { color } from "../../resources";
import { TextStyle } from "./styled";
/*

    TextLarge  18px --> header
    TextMedium 16px--> title card
    TextSmall 14px --> menu, detail
    TextXSMall 12px --> ข้อความ 'โปรดระบุ'
*/

interface IText {
  text?: string | number;
  color?: string;
  bold?: boolean;
  align?: "center" | "right" | "left";
  size?: "XS" | "L" | "M" | "XL" | "S";
  onClick?: () => void;
}

interface IHeader {
  text: string;
  divider?: boolean;
}

export const TextXSMall = ({ color, bold, text, align, size }: IText) => {
  return (
    <TextStyle color={color} bold={bold} size={"12px"} align={align}>
      {text}
    </TextStyle>
  );
};

export const Text = ({ color, bold, text, align, size }: IText) => {
  let fontSizes: string = "";
  switch (size) {
    case "XS":
      fontSizes = "12px";
      break;
    case "L":
      fontSizes = "16px";
      break;
    case "M":
      fontSizes = "14px";
      break;
    case "XL":
      fontSizes = "27px";
      break;
    default:
      fontSizes = "13px";
  }
  return (
    <TextStyle color={color} bold={bold} size={fontSizes} align={align}>
      {text}
    </TextStyle>
  );
};

export const TextLink = ({ size, text, onClick }: IText) => {
  return (
    <TextStyle
      color={color.link}
      size={size || "13px"}
      onClick={() => onClick && onClick()}
      style={{ textDecoration: "underline", cursor: "pointer" }}
    >
      {text}
    </TextStyle>
  );
};

export const TextHeader = ({ text, divider }: IHeader) => {
  return (
    <>
      <Text size={"L"} text={text} bold />
      {divider && <Divider style={{ marginTop: 5 }} />}
    </>
  );
};
